import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { ArrowLeft } from 'lucide-react';
import { api, pickLocale } from '@/lib/api';
import { Img } from '@/lib/ui';
import { useSEO } from '@/lib/useSEO';

export default function BlogDetail() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.split('-')[0];
  const { slug } = useParams();
  const { data: p, isLoading, isError } = useQuery({ queryKey: ['blog', slug], queryFn: async () => (await api.get(`/blog/${slug}`)).data });
  useSEO({ title: p ? pickLocale(p.title, lang) : 'Blog', description: p ? pickLocale(p.excerpt, lang) : undefined });

  if (isLoading) return <div className="min-h-[60vh] flex items-center justify-center text-ukgm-slate">{t('common.loading')}</div>;
  if (isError || !p) return <div className="min-h-[60vh] flex items-center justify-center text-ukgm-slate">Not found</div>;

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="blog-detail-page">
      <Link to="/blog" className="inline-flex items-center gap-2 text-ukgm-blue hover:text-ukgm-gold text-sm"><ArrowLeft className="w-4 h-4" /> {t('blog.read_all')}</Link>
      <h1 className="mt-5 font-serif text-4xl md:text-5xl text-ukgm-blue font-semibold leading-tight">{pickLocale(p.title, lang)}</h1>
      <div className="mt-4 text-sm text-ukgm-slate">{t('blog.author_by')} <span className="text-ukgm-blue font-semibold">{p.author}</span></div>
      <Img src={p.cover_image} className="mt-8 rounded-2xl w-full h-[380px] border border-ukgm-gold/25 object-cover" label={t('common.image_placeholder')} />
      <div className="mt-8 text-lg leading-relaxed text-ukgm-charcoal whitespace-pre-line">{pickLocale(p.content, lang) || pickLocale(p.excerpt, lang)}</div>
    </article>
  );
}
